// application/states/relatorios-dash/relatorios-dash-slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface RelatoriosDashState {
    acess: any
    quantitative: any
    syntetic: any
    receita: any
    consumoAnalytic: any
    loading: boolean
    error: string | null
    meusRelatorios: any[]
    carregandoRelatorios: boolean
    relatorioExpandido: number | null
    pageMeusRelatorios: number
    rowsPerPageMeusRelatorios: number
    reprocessandoIds: number[]
}

const initialState: RelatoriosDashState = {
    acess: null,
    quantitative: null,
    syntetic: null,
    receita: null,
    consumoAnalytic: null,
    loading: false,
    error: null,
    meusRelatorios: [],
    carregandoRelatorios: false,
    relatorioExpandido: null,
    pageMeusRelatorios: 0,
    rowsPerPageMeusRelatorios: 10,
    reprocessandoIds: []
}

export const relatoriosDashSlice = createSlice({
    name: 'relatoriosDash',
    initialState,
    reducers: {
        setRelatorioAcess: (state, action: PayloadAction<any>) => {
            state.acess = action.payload
        },
        setRelatorioQuantitative: (state, action: PayloadAction<any>) => {
            state.quantitative = action.payload
        },
        setRelatorioSyntetic: (state, action: PayloadAction<any>) => {
            state.syntetic = action.payload
        },
        setRelatorioReceita: (state, action: PayloadAction<any>) => {
            state.receita = action.payload
        },
        setRelatorioConsumoAnalytic: (state, action: PayloadAction<any>) => {
            state.consumoAnalytic = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        },
        setMeusRelatorios: (state, action: PayloadAction<any[]>) => {
            const novos = action.payload
            const antigos = state.meusRelatorios || []
            state.meusRelatorios = novos.map((r: any) => {
                const antigo = antigos.find((a: any) => a.IdRelatorioFila === r.IdRelatorioFila)
                const tinhaArquivoConfirmado = antigo?.hasFiles && antigo?.files?.length
                const novoNaoTemArquivo = !(r.hasFiles && r.files?.length)
                const continuaProcessado = r.statusText === 'PROCESSADO'
                if (tinhaArquivoConfirmado && novoNaoTemArquivo && continuaProcessado) {
                    return { ...r, hasFiles: true, files: antigo.files }
                }
                return r
            })
        },
        setCarregandoRelatorios: (state, action: PayloadAction<boolean>) => {
            state.carregandoRelatorios = action.payload
        },
        setRelatorioExpandido: (state, action: PayloadAction<number | null>) => {
            state.relatorioExpandido = action.payload
        },
        setPageMeusRelatorios: (state, action: PayloadAction<number>) => {
            state.pageMeusRelatorios = action.payload
        },
        setRowsPerPageMeusRelatorios: (state, action: PayloadAction<number>) => {
            state.rowsPerPageMeusRelatorios = action.payload
        },
        setRelatorioSemArquivo: (state, action: PayloadAction<number>) => {
            const id = action.payload
            const idx = state.meusRelatorios.findIndex((r: any) => r.IdRelatorioFila === id)
            if (idx >= 0) {
                state.meusRelatorios[idx] = { ...state.meusRelatorios[idx], hasFiles: false, files: [] }
            }
        },
        addReprocessandoId: (state, action: PayloadAction<number>) => {
            if (!state.reprocessandoIds.includes(action.payload)) {
                state.reprocessandoIds.push(action.payload)
            }
        },
        removeReprocessandoId: (state, action: PayloadAction<number>) => {
            state.reprocessandoIds = state.reprocessandoIds.filter(id => id !== action.payload)
        }
    }
})

export const {
    setRelatorioAcess,
    setRelatorioQuantitative,
    setRelatorioSyntetic,
    setRelatorioReceita,
    setRelatorioConsumoAnalytic,
    setLoading,
    setError,
    setMeusRelatorios,
    setCarregandoRelatorios,
    setRelatorioExpandido,
    setPageMeusRelatorios,
    setRowsPerPageMeusRelatorios,
    setRelatorioSemArquivo,
    addReprocessandoId,
    removeReprocessandoId
} = relatoriosDashSlice.actions

export default relatoriosDashSlice.reducer